/* Belchic size chart cm/inch toggle (data-*非依存版)
   - 既存チャート(data-cm/data-inch/data-unit あり)はその属性を使う(従来通り・誤差ゼロ)
   - 商品説明欄に貼って data-* が剥がされたチャートは、cm数値テキストから inch を自動計算
   - ボタンは data-unit が無くても "CM"/"IN"/"INCH" のテキストで判定 */
(function () {
  "use strict";
  var K = 2.54;
  var NUM = /^\s*\d+(?:\.\d+)?(?:\s*-\s*\d+(?:\.\d+)?)?\s*$/; // "57.5" or "54-56"
  function toInch(s) {
    return s.replace(/\d+(?:\.\d+)?/g, function (n) {
      return (parseFloat(n) / K).toFixed(1);
    });
  }
  function btnUnit(b) {
    var u = b.getAttribute("data-unit");
    if (u) return u === "inch" ? "inch" : "cm";
    var L = (b.textContent || "").trim().toUpperCase();
    if (L === "CM") return "cm";
    if (L === "IN" || L === "INCH") return "inch";
    return null;
  }
  // 変換対象セルを {el, cm, inch} で返す
  function cellsOf(container) {
    var out = [];
    var attr = container.querySelectorAll("td[data-cm][data-inch]");
    if (attr.length) { // 属性モード(既存)
      Array.prototype.forEach.call(attr, function (td) {
        out.push({ el: td, cm: td.getAttribute("data-cm"), inch: td.getAttribute("data-inch") });
      });
      return out;
    }
    // 計算モード(剥がされたチャート): 各行の先頭列(サイズ名)以外の数値セル
    Array.prototype.forEach.call(container.querySelectorAll("tr"), function (tr) {
      var tds = tr.querySelectorAll("td");
      Array.prototype.forEach.call(tds, function (td, i) {
        if (i === 0) return; // サイズ名列はスキップ
        var cached = td.getAttribute("data-cm-cache");
        var t = (cached != null ? cached : td.textContent).trim();
        if (NUM.test(t)) {
          if (cached == null) td.setAttribute("data-cm-cache", t); // 初回に元cmを退避
          out.push({ el: td, cm: t, inch: toInch(t) });
        }
      });
    });
    return out;
  }
  function setUnit(container, unit) {
    cellsOf(container).forEach(function (c) {
      c.el.textContent = unit === "inch" ? c.inch : c.cm;
    });
    Array.prototype.forEach.call(container.querySelectorAll("button"), function (b) {
      var u = btnUnit(b);
      if (!u) return;
      var active = u === unit;
      b.style.backgroundColor = active ? "#000" : "#fff";
      b.style.color = active ? "#fff" : "#333";
    });
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".size-chart-container button, .size-chart-container [data-unit]");
    if (!btn) return;
    var u = btnUnit(btn);
    if (!u) return;
    var c = btn.closest(".size-chart-container");
    if (c) setUnit(c, u);
  });
})();
